import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'react-bootstrap';
import PropdocsModal from '../../../components/modal/PropdocsModal';
import EditExpiryDateFormik from '../../../forms/EditExpiryDateFormContainer';

const EditExpiryDateModal = ({
  showModal,
  onModalHide,
  date,
  organizationRequestId,
  onSuccess,
}: {
  showModal: boolean;
  onModalHide: () => void;
  date: string;
  organizationRequestId: string;
  onSuccess?: () => void;
}) => {
  // Create containers for the form
  const BodyContainer = ({ children }: { children: React.ReactNode }) => <div>{children}</div>;

  const ActionsContainer = ({ children }: { children: React.ReactNode }) => (
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', paddingTop: '1.5rem' }}>{children}</div>
  );

  return (
    <PropdocsModal
      show={showModal}
      setShow={onModalHide}
      size="md"
      title={
        <header>
          <FormattedMessage id="title.expiry-date-modal" defaultMessage="Edit Membership Expiry" />
        </header>
      }
    >
      <EditExpiryDateFormik
        date={date}
        organizationRequestId={organizationRequestId}
        onModalHide={onModalHide}
        onSuccess={onSuccess}
        bodyContainer={BodyContainer}
        actionsContainer={ActionsContainer}
        renderSecondaryAction={() => (
          <Button variant="link" className="text-secondary" onClick={onModalHide}>
            <FormattedMessage id="cta.cancel" defaultMessage="Cancel" />
          </Button>
        )}
      />
    </PropdocsModal>
  );
};

export default EditExpiryDateModal;
